import BlankTargetLink from './BlankTargetLink'

export default BlankTargetLink
